import { createBrowserClient } from '@supabase/ssr'
import { ENV_CONFIG } from 'common/envs/constants'

let browserClient: ReturnType<typeof createBrowserClient> | null = null

export function getSupabaseBrowserClient() {
  if (browserClient) return browserClient

  browserClient = createBrowserClient(
    ENV_CONFIG.supabaseUrl,
    ENV_CONFIG.supabasePublishableKey || ENV_CONFIG.supabaseAnonKey
  )

  return browserClient
}
